
import { Vue, Component, Prop } from "vue-property-decorator";



@Component({
  components: {

  },
  // apollo: {
  //     update(data) {
  //       this.searchableListConfig.total = data.total.aggregate.count;
  //       this.searchableListConfig.loadedCount = data.document.length;
  //       return data.document;
  //     },
  //   },
})
export default class DocumentTable extends Vue {
  @Prop({ type: String, required: false, default: "#ffffff" }) readonly bg!: string;


}
